import { AutogenModelCalculateOrderCharges, AutogenRowCalculateOrderCharges } from "./autogen/AutogenModelCalculateOrderCharges";

export class ModelCalculateOrderCharges extends AutogenModelCalculateOrderCharges<RowCalculateOrderCharges> {
    constructor() {
        super(RowCalculateOrderCharges);
    }
}

export class RowCalculateOrderCharges extends AutogenRowCalculateOrderCharges {
}